export default __webpack_public_path__ + "static/media/img1.a468cb55.jpg";